import React, { useEffect, useState } from 'react'
import Navbar from './Navbar'
import Footer from './Footer'

const Courses = () => {

    const [courses, setCourses] = useState([]);

  useEffect(() => {
    fetch("https://goforen.com/go_foren/get_course_data/")
      .then((res) => res.json())
      .then((data) => setCourses(data))
      .catch((err) => console.error("Failed to fetch courses:", err));
  }, []);

    //    <div>
    //   <h1>Courses</h1>
    //   <ul>
    //     {courses.map((course, index) => (
    //       <li key={index}>{course.course_name}</li> // adjust key name as needed
    //     ))}
    //   </ul>
    // </div>

      const [background, setBackground] = useState("");
    
      useEffect(() => {
        const backgroundUrl ="/assets/pic/breadcrumb-bg.jpg";
        setBackground(backgroundUrl);
      }, []);
      
              const [background12, setBackground12] = useState("");
            
              useEffect(() => {
                const backgroundUrl12 = "assets/img/bg/blog_bg.png";
                setBackground12(backgroundUrl12);
              }, []);
  return (
    <>
      <div>
         <Navbar />
                 {/* <!-- breadcrumb start --> */}
                 <section
  className="breadcrumb pos-rel bg_img"
  style={{ 
    backgroundImage: `url(${background})`, 
    minHeight: '400px',
    position: 'relative',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  }}
>
  {/* Overlay */}
  <div style={{
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)', 
    zIndex: 1
  }}></div>

  <div className="container" style={{ position: 'relative', zIndex: 2 }}>
    <div className="breadcrumb__content">
    <h2 className="breadcrumb__title" style={{color:'#fff'}}>Courses</h2>
            <ul className="breadcrumb__list clearfix">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>
              <li className="breadcrumb-item">Courses</li>
            </ul>
    </div>
  </div>
      
        {/* <div className="breadcrumb__circle">
          <span
            className="big"
            data-parallax='{"y" : 100, "scale" : 0.1}'
          ></span>
          <span
            className="small"
            data-parallax='{"y" : 100, "scale" : 0.1}'
          ></span>
        </div>
        <div className="breadcrumb__shape">
          <div className="shape shape--1">
            <div className="shape-inner" data-parallax='{"x":-50,"y":80}'>
              <img src="assets/img/shape/br_shape1.png" alt="" />
            </div>
          </div>
          <div className="shape shape--2">
            <div className="shape-inner" data-parallax='{"x":50,"y":-90}'>
              <img src="assets/img/shape/br_shape2.png" alt="" />
            </div>
          </div>
        </div> */}
      </section>
      {/* <!-- breadcrumb end --> */}
         {/* What is a visa start  */}
         <section className="about pos-rel  pt-120">
        <div className="container">
          
          <div className="sec-title sec-title--big style-2 mb-20">
       
              <h3 style={{marginBottom:'15px'}}>  Language Coaching for Study & Work Abroad</h3>
          
            <p style={{marginBottom:'30px'}}> 
           At GO FOREN, we know that your dream to study or work abroad begins with proving your ability to communicate in English. Universities, employers, and immigration authorities in most English-speaking countries require proof of English language proficiency. That is why international language tests such as IELTS, TOEFL, and PTE are compulsory.
            </p>
            <p style={{marginBottom:'30px'}}> 
           Without these scores, applications often get delayed or rejected. But with the right guidance, you can achieve the score you need and move forward with confidence.
            </p>

          <h3 style={{marginBottom:'15px'}}>Why are Language Tests Necessary?</h3>
           <p style={{marginBottom:'30px'}}> 
           English is the global language for education, business, and professional growth. Universities in countries like Canada, USA, UK, Australia, New Zealand, and Europe need assurance that students can understand lectures, write academic papers, and interact effectively. Employers and immigration departments also use these scores as proof of communication skills.
            </p>
           <p style={{marginBottom:'30px'}}> 
          Scoring well not only helps you meet admission or visa requirements, but also boosts your chances of scholarships and job opportunities abroad.
            </p>

             <h3 style={{marginBottom:'15px'}}> GO FOREN Coaching Approach</h3>
            
         <ul style={{ paddingBottom: "10px", listStyle:"none" }}>
               <p>We offer a flexible learning system that adapts to your needs:</p>
              <li style={{ textAlign: "justify", marginBottom:'6px' }}> <b>•	Online Coaching</b> – Attend live classes from anywhere in India with interactive sessions, doubt clearing, and mock tests.</li>
              <li style={{ textAlign: "justify", marginBottom:'6px' }}> <b>•	Offline Coaching</b> – Join our classroom sessions with personalized attention, small batches, and practice exercises.</li>
              <li style={{ textAlign: "justify", marginBottom:'6px' }}> <b>•	Customized Study Plans</b> – Based on your target score, course, and country of choice.</li>
              <li style={{ textAlign: "justify", marginBottom:'6px' }}> <b>•	Practice Tests & Feedback</b> – Regular assessments that simulate real exam conditions to help you improve steadily.</li>
              <li style={{ textAlign: "justify", marginBottom:'6px' }}> <b>•	Expert Trainers</b> – Experienced faculty with strong knowledge of exam patterns, tips, and strategies.</li>
              </ul>
        <p style={{marginBottom:'30px'}}> 
         At GO FOREN, our USP is result-oriented coaching. We do not just teach; we mentor you until you are confident to achieve your target band or score.
            </p>

  <h3 style={{marginBottom:'15px'}}>Which Test is Right for You?</h3>
 <ul style={{ paddingBottom: "10px", listStyle:"none" }}>
               <p>Here’s a quick guide to the most popular English language tests:</p>
              <li style={{ textAlign: "justify", marginBottom:'6px' }}> <b>•	IELTS (International English Language Testing System) </b> – Widely accepted in UK, Canada, Australia, New Zealand, Europe. Assesses listening, reading, writing, and speaking. Academic & General Training versions available.</li>
              <li style={{ textAlign: "justify", marginBottom:'6px' }}> <b>•	TOEFL (Test of English as a Foreign Language) </b> – Preferred in the USA and Canada. Internet-based test focusing on academic English used in university settings.</li>
              <li style={{ textAlign: "justify", marginBottom:'6px' }}> <b>•	PTE (Pearson Test of English Academic) </b> – Computer-based test accepted in Australia, New Zealand, Canada, and some UK universities. Quick results, reliable scoring system.</li>
              
              </ul>
<p style={{marginBottom:'30px'}}> 
         Each test has its own strengths, and the right choice depends on your destination, course, and career plan.
            </p>


            <ul style={{ paddingBottom: "10px", listStyle:"none" }}>
              
              {/* <!-- visa type start --> */}
        <section className="visa-type pt-120 pb-135">
            <div className="container">
                <div className="sec-title text-center mb-60">
                    <h2 className="wow skewIn">Courses </h2> <br />
                  <p style={{justifyContent:'center',display:'flex',marginTop:'15px'}}>"Explore a wide range of career-focused courses tailored to help you qualify for your desired visa destination."</p>
                </div>
                <div className="row justify-content-md-center mt-none-30">
  {courses.map((course, index) => (
    <React.Fragment key={course.id}>
      <div className="col-lg-4 col-md-6 mt-30">
        <div className="xb-service">
          <div className="xb-item--inner"  style={{
        backgroundImage: 'linear-gradient(135deg, rgba(214, 131, 48, 0.4), rgba(158, 63, 63, 0))',
        padding: '20px',
        borderRadius: '10px'
      }}>
                        <a href={`/Course-details?id=${course.id}`}>
            <div className={`xb-item--icon color${(index % 5) + 1} mb-50`}>
              <img src={`assets/img/icon/sv_0${(index % 5) + 1}.svg`} alt={course.course_name} />
            </div>
            <div className="xb-item--holder">
              <h3 className="xb-item--title mb-20">
                <a href={`/Course-details?id=${course.id}`}>{course.course_name}</a>
              </h3>
              <p style={{ color: '#787B84' }}
                dangerouslySetInnerHTML={{
                  __html: course.description.replace(/<[^>]+>/g, '').slice(0, 140) + '...',
                }}
              />
            </div>
            </a>

          </div>
        </div>
      </div>

      {/* Insert a blank column after the second item (index 1) */}
      {/* {index === 1 && (
        <div className="col-lg-4 mt-30"></div>
      )} */}
    </React.Fragment>
  ))}
                
                </div>
            </div>
        </section>
        {/* <!-- visa type end --> */}


<ul style={{ paddingBottom: "10px", listStyle:"none" }}>
               <p>OTHER POPULAR TESTS Perfect Here’s the complete set of 25-word notes on additional English proficiency exams, now including CAEL:</p>
              <li style={{ textAlign: "justify", marginBottom:'6px' }}> <b>•	CELPIP (Canadian English Language Proficiency Index Program) </b> – Canadian-focused exam for immigration and PR. Tests listening, reading, writing, speaking. Accepted by IRCC for permanent residency and citizenship applications.</li>
              <li style={{ textAlign: "justify", marginBottom:'6px' }}> <b>•	Duolingo English Test </b> – Online test with quick results, affordable fees, and wide acceptance. Convenient for students applying to universities in USA, Canada, UK, and Europe.</li>
              <li style={{ textAlign: "justify", marginBottom:'6px' }}> <b>•	CEFR (Common European Framework of Reference for Languages) </b> – Global standard measuring English skills from A1 (beginner) to C2 (proficient). Recognized across Europe for study, work, and migration.</li>
              <li style={{ textAlign: "justify", marginBottom:'6px' }}> <b>•	OET (Occupational English Test) </b> – Designed for healthcare professionals like doctors and nurses. Accepted in UK, Australia, New Zealand, and Ireland for licensing and work purposes.</li>
              <li style={{ textAlign: "justify", marginBottom:'6px' }}> <b>•	Cambridge English Exams (C1 Advanced, C2 Proficiency) </b> –  Widely recognized across Europe and UK. Proves advanced English communication ability for academic studies, work, and immigration pathways.</li>
              <li style={{ textAlign: "justify", marginBottom:'6px' }}> <b>•	CAEL (Canadian Academic English Language Test) </b> –   Computer-delivered test assessing English in academic contexts. Accepted by Canadian universities and colleges for study admissions. Closely aligned with classroom tasks.</li>
              
              </ul>


              <li style={{ textAlign: "justify", marginBottom:'6px' }}>
              <span className="sec-title--sub"  style={{marginTop:'25px'}}>
 <img src="assets/img/icon/h_star.png" alt="" />
              Standardized     Exams
              <img src="assets/img/icon/h_star.png" alt="" />
            </span>
             
               <p>The exams required for various courses will be different. Depending on the courses of your choice, you will be required to give only one standardized test.

Here is a table describing exam requirement according to the course of your choice –</p>
              </li>
             
            </ul>
           
           <br />
           <div className="table-responsive">
      
<div className="table-responsive">
    <table className="table table-bordered">
        <thead className="thead-light">
            <tr>
                <th>Courses/Programs</th>
                <th>Standardized Tests</th>
                <th>Preferred English Language Tests (by Country)</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th>Undergraduate</th>
                <td>SAT or ACT</td>
                <td>
                    TOEFL for US, IELTS or PTE for Canada, UK, Australia, New Zealand, CAE or CPE for UK
                </td>
            </tr>
            <tr>
                <th>MBA</th>
                <td>GMAT or GRE</td>
                <td>
                    TOEFL for US, IELTS or PTE for Canada, UK, Australia, New Zealand, CAE or CPE for UK
                </td>
            </tr>
            <tr>
                <th>MS or PG Degree</th>
                <td>GRE</td>
                <td>
                    TOEFL for US, IELTS or PTE for Canada, UK, Australia, New Zealand, CAE or CPE for UK
                </td>
            </tr>
            <tr>
                <th>Certificate Course</th>
                <td>–</td>
                <td>
                    TOEFL for US, IELTS or PTE for Canada, UK, Australia, New Zealand, CAE or CPE for UK
                </td>
            </tr>
        </tbody>
    </table>
</div>
<p style={{marginBottom:'30px'}}> 
        Your study or career abroad depends on the right preparation. With <b>GO FOREN’s coaching for IELTS, TOEFL, and PTE,</b>  you get expert training, flexible options, and focused strategies to achieve success.
            </p>
            <p style={{marginBottom:'30px'}}> <b>GO FOREN – Building Your Global Future, One Score at a Time.</b> </p>
</div>

          </div>
        </div>
        <div className="about-shape">
          <div className="shape shape--1">
            <div className="shape-inner" data-parallax='{"x":-50,"y":-80}'>
              <img src="assets/img/shape/a_shape1.png" alt="" />
            </div>
          </div>
          <div className="shape shape--2" style={{ top: "70%", right: "7%" }}>
            <div className="shape-inner" data-parallax='{"x":50,"y":-80}'>
              <img src="assets/img/shape/a_shape2.png" alt="" />
            </div>
          </div>
        </div>
      </section>

      {/* What is a visa end  */}
    {/* working time  */}
    <div style={{background:'#edf3f5',padding:'30px 0px'}}>
  <div className="container">
        <div
          className="xb-newsletter1 pos-rel "
          style={{
            backgroundImage: `url(${background12})`,
            // minHeight: '400px',
            position: "relative",
            backgroundSize: "cover",
            backgroundPosition: "center",
            margin: "30px 0px",
          }}
        >
          <div className="row">
            <div className="col-12">
              <div>
                <div className="sec-title mb-40 text-center">
                  <h2 className="mb-20 wow skewIn">Our Working Time</h2>
                  <p style={{ textAlign: "center" }}>
                    We are available throughout the week to help you with your
                    visa and training needs.
                  </p>
                </div>

                <div className="row justify-content-center text-center">
                  <div
                    className="col-lg-3 mt-30 col-md-6"
                    style={{
                      boxShadow: " 0px 14px 19px rgb(221 229 236)",
                      padding: "20px",
                      margin: "5px",
                    }}
                  >
                    <div>
                      <h5 className="mb-2">Monday - Saturday :</h5>
                      <p style={{ textAlign: "center" }}>
                        10.00 a.m. to 6.30 p.m.
                      </p>
                    </div>
                  </div>
                  {/* <div
                    className="col-lg-3 mt-30 col-md-6"
                    style={{
                      boxShadow: "0px 14px 19px rgb(221 229 236)",
                      padding: "20px",
                      margin: "5px",
                    }}
                  >
                    <h5 className="mb-2">Sunday :</h5>
                    <p style={{ textAlign: "center" }}>
                      10.00 a.m. to 12.30 p.m.
                    </p>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      {/* workingtime end  */}
          <Footer />
      </div>
    </>
  )
}

export default Courses